exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn {\n    margin-bottom: 5px;\n    margin-right: 5px;\n    padding: 0px 0px 0px 3px;\n\n}\n\n.custom-width{\n    margin-bottom: 0px !important;\n    width:  200px !important;\n}\n\n.custom-radius {\n    border-radius: 0px;\n    border-right: none;\n    border-top: none;\n    border-bottom: none;\n}\n.btn-circle {\n    width: 30px;\n    height: 30px;\n    padding: 6px 0px;\n    border-radius: 15px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 1.42857;\n}\n.custom-glyph {\n    padding-right: 0px;\n}\n.custom-team-btn {\n    padding: 4px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accounts/show/show.component.css
// module id = ../../../../../src/app/accounts/show/show.component.css
// module chunks = main